import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'sortByStatus',
})
export class SortByStatusPipe implements PipeTransform {
  sortListBydate(list, direction, column): any {
    list.sort((a: any, b: any) => {
      const left = Number(new Date(a[column]));
      const right = Number(new Date(b[column]));
      return direction === '-' ? right - left : left - right;
    });
  }

  transform(array: Array<any>, args: string): Array<any> {
    const direction = args[0][0];
    const column = args.replace('-', '');
    const activePolictList = [];
    const inactivePolicyList = [];
    const cancelPolicyList = [];

    if (array != undefined && array.length > 0) {
      for (let i = 0; i < array.length; i++) {
        if (array[i].policyStatus === 'ACTIVE') {
          activePolictList.push(array[i]);
        } else if (array[i].policyStatus === 'INACTIVE') {
          inactivePolicyList.push(array[i]);
        } else {
          cancelPolicyList.push(array[i]);
        }
      }

      this.sortListBydate(activePolictList, direction, column);
      this.sortListBydate(inactivePolicyList, direction, column);
      this.sortListBydate(cancelPolicyList, direction, column);

      array = [];
      array = array.concat(
        activePolictList,
        inactivePolicyList,
        cancelPolicyList
      );
    }
    return array;
  }
}
